import endpoint from "../../config/endpoints";

export const MyLeaveJson = {
  showSaveNextBtn: true,
  formPath: "/my-leave-form",
  apiBaseURL: endpoint.leaveApply,
  changeExcel: endpoint.exportData,
  screenTitle: "My Leave",
  showAddButton: true,
  showPdfDownload: false,
  pdfFileName: "MyLeave",
  showExcelDownload: true,
  excelFileName: "Myleave",
  // formPathView: "/my-claim-view",
  tableColumnsToFilter: [
    {
      columnDisplayName: "Leave Type",
      columnKeyName: "leaveTypeName",
      isChecked: true,
    },
    {
      columnDisplayName: "Subject",
      columnKeyName: "leaveReason",
      isChecked: true,
    },
    {
      columnDisplayName: "From Date",
      columnKeyName: "fromDate",
      isChecked: true,
    },
    {
      columnDisplayName: "To Date",
      columnKeyName: "toDate",
      isChecked: true,
    },
    {
      columnDisplayName: "No.Of Days",
      columnKeyName: "noOfDays",
      isChecked: true,
    },
    {
      columnDisplayName: "Status",
      columnKeyName: "statusForTable",
      isChecked: true,
    },

  ],
  fieldMeta: [
    {
      label: "Leave Type",
      controlType: "autocomplete",
      placeHolder: "Select Leave Leave",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "leaveTypeDetail",
      dataKey: "leaveType",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Subject",
      controlType: "textfield",
      placeHolder: "Enter Subject",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "subject",
      isMandatory: true,
    },
    {
      label: "Leave To",
      controlType: "textfield",
      placeHolder: "Leave To",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "leaveTo",
      isMandatory: true,
      disableTrue: true,
    },

    {
      label: "Leave Duration",
      controlType: "radiogroup",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "leaveFor",
      tableDataKey: "leaveFor",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Full Day",
          value: "0",
        },
        {
          label: "First Half",
          value: "1",
        },
        {
          label: "Second Half",
          value: "2",
        },
      ],
      isMandatory: true,
    },
    {
      label: "Start Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromDate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "toDate-le",
    },
    {
      label: "End Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "toDate",
      addOne: false,
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "fromDate-ge",
    },
    {
      label: "Description",
      controlType: "textfield",
      placeHolder: "Enter Description",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "description",
      isMandatory: true,
    }
  ],
  fieldMetaForEdit: [
    {
      label: "Leave Type",
      controlType: "autocomplete",
      placeHolder: "Select Leave Leave",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "leaveTypeDetail",
      dataKey: "leaveType",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Subject",
      controlType: "textfield",
      placeHolder: "Enter Subject",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "subject",
      isMandatory: true,
    },
    {
      label: "Leave To",
      controlType: "textfield",
      placeHolder: "Leave To",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "leaveTo",
      isMandatory: true,
      disableTrue: true,
    },

    {
      label: "Leave Duration",
      controlType: "radiogroup",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "leaveFor",
      tableDataKey: "leaveFor",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Full Day",
          value: "0",
        },
        {
          label: "First Half",
          value: "1",
        },
        {
          label: "Second Half",
          value: "2",
        },
      ],
      isMandatory: true,
      disableTrue: true,
    },
    {
      label: "Start Date",
      controlType: "textfield",
      placeHolder: "Start Date",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromDate",
      isMandatory: true,
      disableTrue: true,
    },
    {
      label: "End Date",
      controlType: "textfield",
      placeHolder: "End Date",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "toDate",
      isMandatory: true,
      disableTrue: true,
    },

    {
      label: "Description",
      controlType: "textfield",
      placeHolder: "Enter Description",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "description",
      isMandatory: true,
    }
  ],

  searchList: [
    {
      label: "Month",
      controlType: "monthpicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "month",
      isMandatory: true,
    },
  ],
};
